export default __webpack_public_path__ + "static/FReg-4x3-DigPack-79599f98c04670e4f7631b52c75f8b00.jpg";